import { Text } from '@eqi-investimentos/react';
import { Button } from '@chakra-ui/react';
import { Icon } from '@/components/atoms/Icon';
import { EDIT_PROFILE_INFO_DRAWER_IDS } from '../utils';
export const EditPasswordButton = () => <Button variant="ghost" onClick={() => window.dispatchEvent(new CustomEvent(`open-chakra-modal-${EDIT_PROFILE_INFO_DRAWER_IDS.password}`))} justifyContent="space-between" pt="2.5" pb="5" w="full" color="content.primary" borderBottom="1px solid" borderColor="border.primary" _hover={{
  color: 'content.brand'
}} data-sentry-element="Button" data-sentry-component="EditPasswordButton" data-sentry-source-file="PasswordButton.tsx">
    <Text size="xl" color="content.primary" fontWeight="normal" data-sentry-element="Text" data-sentry-source-file="PasswordButton.tsx">
      Alterar senha
    </Text>
    <Icon iconName="ChevronRight" w="24" h="24" color="content.brand " data-sentry-element="Icon" data-sentry-source-file="PasswordButton.tsx" />
  </Button>;